import type { QuoteSnapshot, SnapshotLine } from '../../quotes'

export type DiffRow = { kind: 'added' | 'removed' | 'changed'; label: string; before?: string; after?: string }

const key = (l: SnapshotLine) => (l.line_type === 'extra' ? `extra:${l.description}` : `${l.line_type}:${l.ref_code}`)
const label = (l: SnapshotLine, names: (code: string) => string) => (l.line_type === 'extra' ? l.description : names(l.ref_code))
const n = (v: unknown) => Number(v ?? 0)
const line = (l: SnapshotLine) => `${n(l.qty)} × ${n(l.unit_price).toFixed(2)}${n(l.discount) ? ` − ${n(l.discount).toFixed(2)}` : ''}`

/** İki revizyon arasındaki fark: eklenen/çıkarılan/değişen kalemler, iskonto, toplam, tarih ve notlar. */
export function revisionDiff(prev: QuoteSnapshot | undefined, cur: QuoteSnapshot, names: (code: string) => string): DiffRow[] {
  if (!prev) return []
  const out: DiffRow[] = []
  const before = new Map((prev.lines ?? []).map((l) => [key(l), l]))
  const after = new Map((cur.lines ?? []).map((l) => [key(l), l]))
  for (const [k, l] of after) {
    const p = before.get(k)
    if (!p) out.push({ kind: 'added', label: label(l, names), after: line(l) })
    else if (line(p) !== line(l)) out.push({ kind: 'changed', label: label(l, names), before: line(p), after: line(l) })
  }
  for (const [k, l] of before) if (!after.has(k)) out.push({ kind: 'removed', label: label(l, names), before: line(l) })
  const field = (name: string, a: unknown, b: unknown, fmt = (v: unknown) => String(v ?? '')) => {
    if (fmt(a) !== fmt(b)) out.push({ kind: 'changed', label: name, before: fmt(a), after: fmt(b) })
  }
  const money = (v: unknown) => n(v).toFixed(2)
  field('discount_percent', prev.discount_percent, cur.discount_percent, money)
  field('total', prev.total, cur.total, money)
  field('valid_until', prev.valid_until, cur.valid_until)
  field('notes', prev.notes, cur.notes)
  field('show_line_prices', prev.show_line_prices, cur.show_line_prices)
  return out
}
